export default __webpack_public_path__ + "static/media/joe@2x.4e585ea8.png";